<template>
  <div ref="adPlacehold"></div>
</template>

<script>
export default {
  props: {
    placementName: {
      type: String,
      required: true
    },
    instanceName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      placement: null
    };
  },
  mounted() {
    console.log('[PROSPER] add', this.placementName);

    self.__VM.push((admanager, scope) => {
      if (this.placementName === 'vertical_sticky') {
        scope.Config.verticalSticky().display();
      } else if (
        this.placementName === 'horizontal_sticky' ||
        this.placementName === 'mobile_horizontal_sticky' ||
        this.placementName === 'video_slider'
      ) {
        this.placement = scope.Config.get(this.placementName).displayBody();
      } else {
        this.placement = scope.Config.get(this.placementName).display(this.$refs.adPlacehold);
      }
    });
  },
  beforeDestroy() {
    console.log('[PROSPER] removed', this.placementName);

    self.__VM.push((admanager, scope) => {
      if (this.placementName === 'vertical_sticky') {
        scope.Config.verticalSticky().destroy();
      } else if (this.placement) {
        this.placement.remove();
      }
    });
  }
};
</script>
